var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87434 12.9611C9.87434 16.429 12.6956 19.2504 16.1636 19.2504C17.3831 19.2504 18.5223 18.9011 19.4874 18.2978C19.0607 23.2895 14.8621 27.2212 9.76189 27.2212C4.37916 27.2212 0 22.842 0 17.4593C0 15.3641 0.653894 13.3675 1.89134 11.6835L9.76184 0L13.5394 5.60747L11.089 9.24506C10.2943 10.3285 9.87434 11.613 9.87434 12.9611ZM19.8991 10.1223L19.9401 10.1779C20.5382 10.9878 20.8544 11.9503 20.8543 12.9611C20.8543 15.5477 18.7499 17.652 16.1634 17.652C13.5768 17.652 11.4725 15.5478 11.4725 12.9611C11.4725 11.9504 11.7886 10.988 12.3867 10.1779L12.4281 10.1216L12.4359 10.1061L16.1634 4.57261L19.8909 10.1061L19.8991 10.1223Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.d19010da.svg";
export { ForwardRef as ReactComponent };